import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { NachListData } from 'api/nach';
import { maskAllDigitsExceptLastFour } from 'features/nach/utils/maskNumber';
import DashboardActionColumn from '../components/ActionColumn';
function getFullDate(date: string, format = 'DD/MM/YYYY HH:mm:ss') {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format(format);
    return dateMoment;
  }
}
const FilterColumns: ColumnsType<NachListData> = [
  {
    key: 'mandateId',
    title: 'Mandate Request ID',
    dataIndex: 'mandateId',
    fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'loanNo',
    title: 'Loan Number',
    dataIndex: 'loanNo',
    // fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'loanType',
    title: 'Loan Type',
    dataIndex: 'loanType',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'mode',
    title: 'Mandate Type (Mode)',
    dataIndex: 'mode',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'sourceApplicationName',
    title: 'Source Application Name',
    dataIndex: 'sourceApplicationName',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'bankName',
    title: 'Bank Name',
    dataIndex: 'bankName',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'accountNo',
    title: 'Account No',
    dataIndex: 'accountNo',
    ellipsis: true,
    align: 'center',
    render: (record: string) => (
      <Tooltip placement="topLeft" title={maskAllDigitsExceptLastFour(record)}>
        {maskAllDigitsExceptLastFour(record)}
      </Tooltip>
    ),
  },
  {
    key: 'ifscCode',
    title: 'IFSC Code',
    dataIndex: 'ifscCode',
    ellipsis: true,
    align: 'center',

    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record ? record.toUpperCase() : ''}
      </Tooltip>
    ),
  },
  {
    key: 'maxBillingAmount',
    title: 'Maximum Billing Amount',
    dataIndex: 'maxBillingAmount',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'mandateAmount',
    title: 'Mandate Amount',
    dataIndex: 'mandateAmount',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'mandateStatus',
    title: 'Mandate Status',
    dataIndex: 'mandateStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'statusDiscription',
    title: 'Mandate Status Description',
    dataIndex: 'statusDiscription',
    ellipsis: true,
    align: 'center',
    width: 1000,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'requestDate',
    title: 'Request Date',
    dataIndex: 'requestDate',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {getFullDate(record)}
      </Tooltip>
    ),
  },
  {
    key: 'mandateStartDate',
    title: 'Mandate Start Date',
    dataIndex: 'mandateStartDate',
    ellipsis: true,
    align: 'center',
    render: (record) => <Tooltip placement="topLeft">{getFullDate(record, 'DD/MM/YYYY')}</Tooltip>,
  },
  {
    key: 'mandateEndDate',
    title: 'Mandate End Date',
    dataIndex: 'mandateEndDate',
    ellipsis: true,
    align: 'center',
    render: (record) => <Tooltip placement="topLeft">{getFullDate(record, 'DD/MM/YYYY')}</Tooltip>,
  },
  {
    key: 'mandateRemark',
    title: 'Mandate Remark',
    dataIndex: 'mandateRemark',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'umrNo',
    title: 'UMR No',
    dataIndex: 'umrNo',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'approvateMandateID',
    title: 'Approve Mandate ID',
    dataIndex: 'approvateMandateID',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'aproveMandateCreatedOn',
    title: 'Approve Mandate Created On',
    dataIndex: 'aproveMandateCreatedOn',
    ellipsis: true,
    width: 1000,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {getFullDate(record)}
      </Tooltip>
    ),
  },

  {
    key: 'byAgent',
    title: 'Created By',
    dataIndex: 'byAgent',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'apiRemarks',
    title: 'Remark',
    dataIndex: 'apiRemarks',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'View',
    title: 'Action',
    dataIndex: 'View',
    ellipsis: true,
    width: 400,
    align: 'center',
    render: (_, record) => (
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <DashboardActionColumn record={record} />
      </span>
    ),
  },
];

export default FilterColumns;
